import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

export const WrapperGoogleMaps = (Child) => {
  const WrapperComponent = (props) => {
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

    if (!apiKey) {
      console.warn("Prop `apiKey` is required to use Google Maps components.");
    }

    const checkGoogleMapsLoaded = () => {
      return (
        typeof window.google !== "undefined" &&
        typeof window.google.maps !== "undefined" &&
        typeof window.google.maps.Map !== "undefined"
      );
    };

    const [googleReady, setGoogleReady] = useState(checkGoogleMapsLoaded);

    useEffect(() => {
      if (googleReady) return;

      const checker = setInterval(() => {
        if (checkGoogleMapsLoaded()) {
          setGoogleReady(true);
          clearInterval(checker);
        }
      }, 100);

      return () => clearInterval(checker);
    }, [googleReady]);

    useEffect(() => {
      if (!apiKey) return;

      if (checkGoogleMapsLoaded()) {
        setGoogleReady(true);
        return;
      }

      if (!window.document.getElementById("google-maps-cluster")) {
        const js1 = window.document.createElement("script");
        js1.id = "google-maps-cluster";
        js1.async = true;
        js1.defer = true;
        js1.src =
          "https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js";
        window.document.body.appendChild(js1);
      }

      if (
        window.document.getElementById("__googleMapsScriptId") &&
        window.document.getElementById("google-maps-cluster")
      ) {
        return;
      }

      window.googleAsyncInit = () => {
        setGoogleReady(true);
      };

      const js = window.document.createElement("script");
      js.id = "__googleMapsScriptId";
      js.async = true;
      js.defer = true;
      js.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry,visualization&callback=googleAsyncInit&loading=async`;

      window.document.body.appendChild(js);
    }, [apiKey]);

    return <Child {...props} googleReady={googleReady} />;
  };

  WrapperComponent.displayName = `WrapperGoogleMaps(${Child.displayName || Child.name || "Component"})`;

  return WrapperComponent;
};

WrapperGoogleMaps.propTypes = {
  /**
   * You Google Maps api key
   * @see apiKey What is Api Key ? https://developers.google.com/maps/gmp-get-started
   */
  apiKey: PropTypes.string.isRequired,
};
